import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import { Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/About";
import Events from "./pages/Events";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import ChurchOfferings from "./pages/ChurchOfferings";

function App() {
  return (
    <>
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/events" element={<Events />} />
        <Route path="/gallery" element={<Gallery/>}/>
        <Route path="/contact" element={<Contact />} />
        <Route path="/church-offerings" element={<ChurchOfferings />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;